module.exports = __webpack_public_path__ + "img/s_pehlivanov.c4b780c1.jpg";